<template>
  <!-- Aviso arriba del detalle de un pago: la fila es un reembolso, o es un
       pago que tiene reembolsos registrados. -->
  <div
    v-if="isRefund"
    class="refund-banner refund-banner--refund"
    role="status"
  >
    <div class="refund-banner__icon" aria-hidden="true">↩</div>
    <div class="refund-banner__body">
      <div class="refund-banner__title">
        REFUND
        <span class="refund-banner__amount">{{ money(amount) }}</span>
      </div>
      <div v-if="originalId" class="refund-banner__line">
        Refund of payment #{{ originalId }}
        <span v-if="originalReference" class="font-mono text-sm"
          >({{ originalReference }})</span
        >
        <button
          class="refund-banner__link no-print"
          @click="$emit('openPayment', String(originalId))"
        >
          Open original payment
        </button>
      </div>
      <div class="refund-banner__meta">
        <span v-if="by">By {{ by }}</span>
        <span v-if="date">{{ date }}</span>
      </div>
    </div>
  </div>

  <div
    v-else-if="refundedAmount > 0"
    class="refund-banner refund-banner--refunded"
    role="status"
  >
    <div class="refund-banner__icon" aria-hidden="true">↩</div>
    <div class="refund-banner__body">
      <div class="refund-banner__title">
        {{ fullyRefunded ? "REFUNDED" : "PARTIALLY REFUNDED" }}
        <span class="refund-banner__amount"
          >{{ money(refundedAmount) }} of {{ money(amount) }}</span
        >
      </div>
      <div v-if="refunds.length > 0" class="refund-banner__refunds">
        <button
          v-for="refund in refunds"
          :key="refund.id"
          class="refund-banner__chip no-print"
          @click="$emit('openPayment', String(refund.id))"
        >
          #{{ refund.id }} · {{ money(Math.abs(refund.amount)) }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PaymentRefundBanner",
  props: {
    // Esta fila es un reembolso (monto negativo / refund_of_id)
    isRefund: { type: Boolean, default: false },
    // Monto de la fila: el pago o el reembolso (se muestra en valor absoluto)
    amount: { type: [Number, String], default: 0 },
    // Reembolso: pago original
    originalId: { type: [Number, String], default: null },
    originalReference: { type: String, default: null },
    by: { type: String, default: null },
    date: { type: String, default: null },
    // Pago original: lo reembolsado y las filas de reembolso
    refundedAmount: { type: [Number, String], default: 0 },
    refunds: { type: Array, default: () => [] }
  },
  computed: {
    fullyRefunded() {
      return (
        Number(this.refundedAmount) >= Math.abs(Number(this.amount)) - 0.005
      );
    }
  },
  methods: {
    money(value) {
      return `$${Math.abs(Number(value || 0)).toFixed(2)}`;
    }
  }
};
</script>
<style scoped>
.refund-banner {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 12px 16px;
  margin-bottom: 12px;
  border-radius: 8px;
  border-left: 6px solid;
}
.refund-banner--refund {
  background: #fef2f2;
  border-color: #dc2626;
  color: #7f1d1d;
}
.refund-banner--refunded {
  background: #fffbeb;
  border-color: #d97706;
  color: #78350f;
}
.refund-banner__icon {
  font-size: 28px;
  line-height: 1;
  font-weight: 700;
}
.refund-banner__body {
  flex: 1;
  min-width: 0;
}
.refund-banner__title {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0.04em;
}
.refund-banner__amount {
  margin-left: 8px;
  letter-spacing: normal;
}
.refund-banner--refund .refund-banner__amount::before {
  content: "−";
}
.refund-banner__line {
  margin-top: 4px;
}
.refund-banner__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin-top: 4px;
  font-size: 13px;
  opacity: 0.85;
}
.refund-banner__link {
  margin-left: 8px;
  color: #1d4ed8;
  text-decoration: underline;
  font-weight: 600;
}
.refund-banner__refunds {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}
.refund-banner__chip {
  padding: 2px 10px;
  border-radius: 9999px;
  background: #fde68a;
  color: #78350f;
  font-weight: 600;
  font-size: 13px;
}
.refund-banner__chip:hover {
  background: #fcd34d;
}
</style>
